"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reactstrap_1 = require("reactstrap");
const react_1 = __importDefault(require("react"));
exports.BreadCrumbs = ({ tableBreadCrumbs, onSelect, }) => {
    return (react_1.default.createElement(reactstrap_1.Breadcrumb, { className: "bg-transparent" }, tableBreadCrumbs.map((bdc, index) => {
        const { name, action } = bdc;
        return (react_1.default.createElement(reactstrap_1.BreadcrumbItem, { active: index === tableBreadCrumbs.length - 1, key: `super-table-breadcrumb-${index}`, className: "text-capitalize cursor-pointer", onClick: () => action && onSelect({ ...action, action: action.type }) }, name));
    })));
};
//# sourceMappingURL=BreadCrumbs.js.map